import { Game, Types } from "phaser";
import { BootScene } from "./scenes/Boot";

export class App extends Game {

    public quality: number = 1;

    public gameWidth: number;
    public gameHeight: number;


    constructor(config: Types.Core.GameConfig, quality: number) {
        super(config);
        this.gameWidth = Number(config.scale?.width || 0);
        this.gameHeight = Number(config.scale?.height || 0);
        this.quality = quality;
    }
}



window.onload = () => {
    const parentElementId = "game";
    let dpr = window.devicePixelRatio;


    //@ts-ignore
    const baseWidth: number = __WIDTH__;
    //@ts-ignore
    const baseHeight: number = __HEIGHT__;

    new App(
        {
            //@ts-ignore
            title: __GAME_TITLE__,
            //@ts-ignore
            version: __VERSION__,
            type: Phaser.AUTO,
            parent: "game",
            scale: {
                mode: Phaser.Scale.FIT,
                width: baseWidth,
                height: baseHeight,
                parent: 'game',
                autoCenter: Phaser.Scale.CENTER_BOTH,
                autoRound: false
            },
            input: {
                activePointers: 3,
                mouse: true,
                touch: true,
            },
            physics: {
                default: 'arcade',
                arcade: {
                    debug: false
                }
            },
            scene: [
                BootScene
            ],
        }, 1);
}